import React from "react";

import SubNavbar from "../components/SubNavbar";
import Footer from "../components/Footer";
import Surdurulebilirlik from "../components/Surdurulebilirlik";

import Main_Data from "../components/DB_converter";

const SurdurData = Main_Data.SurdurData;

const SektorItems = Main_Data.SektorItems;


const Surdurulebilirlik_Page = ({ change_page }) => {
  return (
    <>
      <SubNavbar change_page={change_page} sectorLabel={"Sustainability"} SektorItems={SektorItems} />
      <Surdurulebilirlik SurdurData={SurdurData} />
      <Footer change_page={change_page}/>
    </>
  );
};

export default Surdurulebilirlik_Page;
